<template>
    <div class="card">
        <div class="card-header header-elements-inline">

            <h6 class="card-title">{{title}}</h6>

            <div class="header-elements">
                <div class="list-icons">
                    <a class="list-icons-item" data-action="collapse" :class="{'rotate-180': state.collapsed}" @click="state.collapsed = !state.collapsed" v-b-toggle="id"></a>
                </div>
            </div>
        </div>

        <b-collapse :id="id" :visible="!state.collapsed">
            <div class="card-body" :class="{'p-0': noPadding}">
                <slot></slot>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name: "BaseCard",
        props: {
            title: {
                type: String
            },
            collapsed: {
                default: false,
                type: Boolean
            },
            noPadding: {
                default: false,
                type: Boolean
            }
        },

        data() {
            return {
                state: {
                    collapsed: this.collapsed
                },
                id: null
            }
        },

        created() {
            this.id = 'card-' + this._uid
        }
    }
</script>

<style scoped>

</style>